import gql from 'graphql-tag'
export default gql`
mutation updateServiceInBulkV2($input: [ServiceInBulkV2Input!]){
    updateServiceInBulkV2(input: $input)
}
`